import {observer} from "mobx-react-lite";
import BenefitManagementStore from "stores/BenefitsManagementStore";

import "./DeleteButton.scss";

import Button from "components/commons/Button/Button";
import Modal from "components/commons/Modal/Modal";
import AppStore from "stores/AppStore";
import {useHistory} from "react-router-dom";
import {useState} from "react";
import Loader from "components/commons/Loader/Loader";

const DeleteButton = () => {
  const { benefitId } = BenefitManagementStore;
  const history = useHistory()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
  const [blockedByEmployees, setBlockedByEmployees] = useState<string[] | null>(null)

  if (!benefitId) return null;

  const {
    i18n: {
      benefits: { remove }
    }
  } = AppStore;

  const handleDeleteClick = () => {
    setIsModalVisible(true);
  }

  const handleConfirmDelete = () => {
    setIsModalVisible(false);
    setIsLoading(true);
    BenefitManagementStore.deleteBenefit(benefitId).then(() => {
      history.push("/benefits")
    }).catch((err) => {
      setIsLoading(false);
      if (err && err.employeeIds) {
        setBlockedByEmployees(err.employeeIds);
      }
    })
  }

  const handleCloseModal = () => {
    setIsModalVisible(false);
  }

  if (isLoading) {
    return <Loader />
  }

  return (
    <div>
      <Button className="c-benefit-form__action-button" text={remove} onClick={handleDeleteClick} danger/>
      <Modal
        isModalVisible={isModalVisible}
        onClose={handleCloseModal}
        onAccept={handleConfirmDelete}
        title="Confirm deletion"
        acceptText="Delete"
      >
        <p>Are you sure you want to delete this item? This action cannot be undone.</p>
      </Modal>
      <Modal
        isModalVisible={!!blockedByEmployees}
        onClose={() => setBlockedByEmployees(null)}
        onAccept={() => setBlockedByEmployees(null)}
        title="Cannot delete benefit"
        acceptText="OK"
        hideCancel
      >
        <p>This benefit is assigned to the following employees:</p>
        <ul>
          {blockedByEmployees && blockedByEmployees.map(id => <li key={id}>{id}</li>)}
        </ul>
      </Modal>
    </div>
  )
}

export default observer(DeleteButton);